import { LOCAL_STORAGE_TOKEN } from "../constans/roles";

export const createAuthHeaders = (reqToken = true, extraHeaders = {}) => {
  const headers = { ...extraHeaders };

  if (reqToken) {
    headers["x-auth-token"] = localStorage.getItem(LOCAL_STORAGE_TOKEN);
  }

  return headers;
};

export async function fetchJson(url, options = {}) {
  const {
    method = "GET",
    reqToken = true,
    headers: extraHeaders = {},
    body,
  } = options;

  const headers = createAuthHeaders(reqToken, extraHeaders);
  const requestOptions = { method, headers };

  if (body !== undefined) {
    if (body instanceof FormData) {
      requestOptions.body = body;
    } else {
      requestOptions.body = JSON.stringify(body);
      requestOptions.headers = {
        "Content-Type": "application/json",
        ...headers,
      };
    }
  }

  const response = await fetch(url, requestOptions);

  let data = null;
  try {
    data = await response.json();
  } catch (err) {
    data = null;
  }

  return {
    ok: response.ok,
    status: response.status,
    data,
  };
}

export default async function fetchGet(url, options = { reqToken: true }) {
  const response = await fetchJson(url, {
    method: "GET",
    reqToken: options.reqToken,
  });

  return response.data;
}
